import React from "react";
import { useTranslation } from "react-i18next";
import { CiEdit } from "react-icons/ci";

import css from "./ButtonEdit.module.css";

const ButtonEdit = (props) => {
  const { onClick, isOnlyIcon } = props;
  const { t } = useTranslation();

  return (
    <button className={css.wrap} onClick={onClick}>
      {isOnlyIcon ? <></> : <span>{t("button-edit-text")}</span>}
      <span className={css.icon}>
        <CiEdit />
      </span>
    </button>
  );
};

export { ButtonEdit };
